var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 13C29.448 13 29 12.552 29 12V9C29 8.449 28.551 8 28 8H19C18.449 8 18 8.449 18 9V12C18 12.552 17.552 13 17 13C16.448 13 16 12.552 16 12V9C16 7.346 17.346 6 19 6H28C29.654 6 31 7.346 31 9V12C31 12.552 30.552 13 30 13Z",
    fill: "#424A56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 26V41C46 42.104 45.104 43 44 43H4C2.896 43 2 42.104 2 41V26",
    fill: "#A4C5F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 32H17V26H12V32ZM31 32H36V26H31V32Z",
    fill: "#5593E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 28H7C3.662 28 1 26.187 1 23V14C1 12.896 1.896 12 3 12H45C46.104 12 47 12.896 47 14V23C47 26.187 44.338 28 41 28H36",
    fill: "#A4C5F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32H13C12.448 32 12 31.552 12 31V27C12 26.448 12.448 26 13 26H16C16.552 26 17 26.448 17 27V31C17 31.552 16.552 32 16 32ZM35 32H32C31.448 32 31 31.552 31 31V27C31 26.448 31.448 26 32 26H35C35.552 26 36 26.448 36 27V31C36 31.552 35.552 32 35 32Z",
    fill: "#5593E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 29C40.448 29 40 28.552 40 28C40 27.448 40.448 27 41 27C43.307 27 46 25.953 46 23V19C46 18.448 46.448 18 47 18C47.552 18 48 18.448 48 19V23C48 26.533 45.122 29 41 29ZM28 29H20C19.448 29 19 28.552 19 28C19 27.448 19.448 27 20 27H28C28.552 27 29 27.448 29 28C29 28.552 28.552 29 28 29ZM7 29C2.878 29 0 26.533 0 23V19C0 18.448 0.448 18 1 18C1.552 18 2 18.448 2 19V23C2 25.953 4.694 27 7 27C7.553 27 8 27.448 8 28C8 28.552 7.553 29 7 29Z",
    fill: "#424A56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtBusiness);
export default __webpack_public_path__ + "static/media/art-business.8d3bdae48deacdf557a49f6c90a60e8e.svg";
export { ForwardRef as ReactComponent };